export const BRAIN_TEAM_STORY_PRESENTATION_MODES = ['deck', 'cinematic_chapter'] as const;

export type BrainTeamStoryPresentationMode = (typeof BRAIN_TEAM_STORY_PRESENTATION_MODES)[number];

export function parseBrainTeamStoryPresentationMode(
  value: unknown,
): BrainTeamStoryPresentationMode | undefined {
  return BRAIN_TEAM_STORY_PRESENTATION_MODES.includes(value as BrainTeamStoryPresentationMode)
    ? (value as BrainTeamStoryPresentationMode)
    : undefined;
}
